import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, CheckCircle } from "lucide-react";

import video1 from "../assests/herovedio.mp4";
import video2 from "../assests/herovedio.mp4";
import video3 from "../assests/herovedio.mp4";

const reviews = [
  {
    name: "Priya Sharma",
    city: "New Delhi",
    rating: 5,
    review:
      "My skin became brighter within just a few weeks. The texture feels smoother and healthier than ever.",
    video: video1,
  },
  {
    name: "Ananya Kapoor",
    city: "Mumbai",
    rating: 5,
    review:
      "Absolutely love the lightweight formula. My skin feels hydrated all day without any irritation.",
    video: video2,
  },
  {
    name: "Riya Mehta",
    city: "Jaipur",
    rating: 5,
    review:
      "The glow is real! Friends started asking what skincare I was using after only a month.",
    video: video3,
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 5000);

    return () => clearInterval(slider);
  }, []);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % reviews.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        <div className="testimonial-heading">
          <span>REAL GLOW STORIES</span>

          <h2>
            Trusted By
            <br />
            Thousands Of Customers
          </h2>

          <p>
            Watch genuine customer experiences and discover why people love
            Celiora skincare.
          </p>
        </div>

        <div className="testimonial-slider">
          <button
            className="slider-arrow left-arrow"
            onClick={prevSlide}
          >
            <ChevronLeft size={22} />
          </button>

          <div className="testimonial-track">
            {reviews.map((item, index) => (
              <div
                className={`testimonial-card ${
                  index === current ? "active-card" : ""
                }`}
                key={index}
              >
                <div className="testimonial-video">
                  <video
                    src={item.video}
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                </div>

                <div className="testimonial-content">
                  <div className="testimonial-stars">
                    ⭐⭐⭐⭐⭐
                  </div>

                  <p>{item.review}</p>

                  <div className="testimonial-user">
                    <h4>{item.name}</h4>

                    <span>{item.city}</span>

                    <div className="verified-user">
                      <CheckCircle size={15} />
                      Verified Buyer
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            className="slider-arrow right-arrow"
            onClick={nextSlide}
          >
            <ChevronRight size={22} />
          </button>
        </div>

        <div className="testimonial-dots">
          {reviews.map((_, index) => (
            <span
              key={index}
              className={current === index ? "active-dot" : ""}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;